import React from "react";
import { Button } from "@tecma/ds";
import "./price-sidebar.scss";
import { currencyFormatter } from "utils/currency";
import { Trans, useTranslation } from "@tecma/i18n";

export interface PriceSidebarProps {
  price: number;
  startDate: string;
  endDate: string;
  onButtonClick: () => void;
}

const PriceSidebar: React.FC<PriceSidebarProps> = ({
  price,
  startDate,
  endDate,
  onButtonClick,
}) => {
  const { t } = useTranslation();
  const formattedPrice = currencyFormatter(price || 0, "EUR", {
    style: "decimal",
    maximumFractionDigits: 2,
  });

  return (
    <div className='highlighted-content price-sidebar'>
      <div className='text-content'>
        <div className='title'>
          <span>
            <Trans
              i18nKey='card-rooms.feature.price'
              values={{
                count: formattedPrice,
              }}
            />
          </span>
          <span className='per-month'>
            <Trans i18nKey='card-rooms.feature.per-month' />
          </span>
        </div>
        <div className='included'>{t("card-rooms.feature.taxes")}</div>
        <div className='period'>
          {startDate} - {endDate}
        </div>
        <Button fluid color='primary' onClick={onButtonClick} className='cta'>
          {t("card-rooms.highlighted-content.dream.firstButton")}
        </Button>
      </div>
    </div>
  );
};

export default PriceSidebar;
